"use strict";


Shopify.theme.jsLogoSlideshow = {
    init: function init($section) {
        // Add settings from schema to current object
        Shopify.theme.jsLogoSlideshow = $.extend(this, Shopify.theme.getSectionData($section));

        this.createSlider();
    },
    createSlider: function createSlider() {

        var mySwiper = new Swiper('.slider-swiper.logo-gallery', {
            // Optional parameters
            loop: true,
            slidesPerView: 7,
            slidesPerGroup: 1,
            autoplay: {
                delay: 1,
                disableOnInteraction: false
            },
            noSwiping: true,
            noSwipingClass: 'swiper-container',
            freeMode: true,
            speed: 3000,
            grabCursor: false,
            spaceBetween: 80,
            // Navigation arrows
            breakpoints: {
                // when window width is >= 480px
                250: {
                    slidesPerView: 3,
                    centeredSlides: true
                },
                480: {
                    slidesPerView: 4,
                    centeredSlides: false
                },
                670: {
                    slidesPerView: 5,
                    centeredSlides: false
                },
                996: {
                    slidesPerView: 7
                },
                1440: {
                    slidesPerView: 8
                }
            }
        });
        // var self = this;
        //     setTimeout(function () {
        //         mySwiper.x = 0;
        //         self.play();
        //     }, 1000);

        // var LogoSlideshowSlider = $('.slider.logo-gallery');
        // var slideData = {
        //     blocks_per_slide: $(window).width() < 1024 ? this.blocks_per_row : 5,
        //     blocks_limit: this.blocks_limit,
        //     cellAlign: "left"
        // };
        // var self = this;
         if($('.slider-swiper.logo-gallery').length != 0) {
             $('.swiper-wrapper').css({'flex-wrap': 'unset'});
         }
        //     const mainTicker = new Flickity('.slider.logo-gallery', {
        //         lazyLoad: 2,
        //         freeScroll: true,
        //         imagesLoaded: true,
        //         draggable: false,
        //         cellAlign: 'center',
        //         autoPlay: false,
        //         wrapAround: true,
        //         pageDots: false,
        //         contain: true,
        //         prevNextButtons: false,
        //         initialIndex: 0,
        //         arrowShape: arrowShape,
        //         on: {
        //             ready: function ready() {
        //                 // Reset layout to avoid collapsing issues
        //                 setTimeout(function () {
        //                     $(LogoSlideshowSlider).flickity('resize');
        //                 }, 500);
        //
        //             }
        //         }
        //     });
        //     setTimeout(function () {
        //         mainTicker.x = 0;
        //         self.play(mainTicker);
        //     }, 1000);
        // }
    },
    unload: function unload($section) {
        // var $slider = $section.find('.flickity-enabled');
        // $slider.flickity('destroy');
    },
    // play: function play(mainTicker){
    //     mySwiper.x -= 1;
    //
    //     // Settle position into the slider
    //     mySwiper.settle(mySwiper.x);
    //     setTimeout(function () {
    //         play(mainTicker);
    //     }, 10);
    //
    // },
};